export default __webpack_public_path__ + "static/media/mariog6.ebbcfbbe.jpg";